interface HeaderProps {
  logoUrl?: string
}

export function Header({ logoUrl }: HeaderProps) {
  return (
    <header className="w-full bg-white border-b border-gray-100 py-4 px-6">
      <div className="max-w-6xl mx-auto flex items-center">
        {logoUrl ? (
          <img 
            src={logoUrl} 
            alt="Logo" 
            className="h-8 w-auto"
          />
        ) : (
          <div className="flex items-center gap-2">
            <div className="w-8 h-8 bg-exness-yellow rounded-lg flex items-center justify-center">
              <svg 
                className="w-5 h-5 text-exness-dark" 
                fill="none" 
                stroke="currentColor" 
                viewBox="0 0 24 24"
              >
                <path 
                  strokeLinecap="round" 
                  strokeLinejoin="round" 
                  strokeWidth={2} 
                  d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" 
                />
              </svg>
            </div>
            <span className="font-semibold text-lg text-exness-dark">
              Icon Generator
            </span>
          </div>
        )}
      </div>
    </header>
  )
}
